import { DocumentSignatureType, DocumentTemplateType } from '@dealstack/shared/lib/generated';

interface Args {
	signatureType: DocumentSignatureType;
	templateType?: DocumentTemplateType;
	isGeneratableDocument?: boolean;
}

/**
 * Generated documents — generatable templates and GDPR notices — are built per investor, so
 * their page count varies and a stored pageNum would not survive. Everything else offered here
 * is a static upload, a pre-fillable AcroForm included: filling one never repaginates it.
 *
 * Deliberately not keyed off `isSignatureSubOptionsLocked`, which exists to force
 * electronic-only signing with no counterparties or witnessing — a rule about roles, not pages.
 */
export const canPlaceSdwSignatures = ({
	signatureType,
	templateType,
	isGeneratableDocument,
}: Args): boolean => {
	const isGeneratedDocument =
		!!isGeneratableDocument || templateType === DocumentTemplateType.GDPR_NOTICE;

	return signatureType === DocumentSignatureType.ELECTRONIC && !isGeneratedDocument;
};
